<template>
  <v-dialog v-model="dialog" max-width="1300">
    <v-card>
      <v-card-title class="redColor text-white">
        <v-row justify="end" class="pa-2">
          <v-btn
            icon
            color="white"
            variant="outlined"
            class="ma-1"
            size="small"
            @click="dialog = false"
          >
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col
            v-for="(part, index) in parts"
            :key="index"
            cols="12"
            sm="6"
            md="3"
            lg="2"
          >
            <v-card class="pa-2" flat>
              <v-row justify="center" no-gutters>
                <v-col
                  cols="12"
                  class="text-center align-center d-flex justify-center"
                >
                  <qr-code :size="150" :text="part._id" />
                </v-col>
                <v-col
                  cols="8"
                  class="d-flex align-center justify-center text-center"
                >
                  <h3>{{ part._id.slice(-6) }}</h3>
                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <v-btn
                        icon
                        variant="text"
                        v-on="on"
                        @click="printSingle(part._id)"
                      >
                        <v-icon>
                          {{ part.printed ? "mdi-printer-off" : "mdi-printer" }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span v-if="part.printed">
                      <v-row align="center" no-gutters>
                        <v-icon small class="mr-1">mdi-printer-off</v-icon>
                        {{ $t("printed_alert") }}
                      </v-row>
                    </span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn variant="outlined" color="primary" @click="print">
          {{ $t("parts.insert_parts.qr_codes.print_qr_codes")
          }}<v-icon size="small" end class="mr-1">mdi-printer</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VueQrCode from "vue-qr-generator"; // eslint-disable-line import/extensions
import QrCode from "qrcode";
import { Printd } from "printd";
import postRequest from "../../api/postRequest";

function printSingleQrCode(id) {
  QrCode.toDataURL(id, (error, url) => {
    // if (error) {
    //   console.log(error);
    // }

    const qrImage = document.createElement("img");
    qrImage.setAttribute("id", "qrImage");
    qrImage.setAttribute("src", url);
    qrImage.style.width = "100px";
    qrImage.style.height = "100px";

    const idComp = document.createElement("span");
    idComp.textContent = id.slice(id.length - 6, id.length);
    idComp.setAttribute("id", "idText");

    const urlComp = document.createElement("span");
    urlComp.textContent = "www.lekotech.com";
    urlComp.setAttribute("id", "urlText");

    const content = document.createElement("div");
    content.setAttribute("id", "content");
    content.appendChild(idComp);
    content.appendChild(qrImage);
    content.appendChild(urlComp);

    const css = [
      `
      @media print {
        @page {
          size: 4cm, 3cm;
          size: portrait;
        }
        body {
          height: 100%;
          width: 100%;
        }
        .hideOnPrint {
          display: none;
        }
        #content {
          padding-top: 5px;
          padding-bottom: 5px;
          display: grid;
        }
        #qrImage {
          margin: 0 auto;
        }
        #idText {
          font-family: "Roboto";
          font-size: 16px;
          text-align: center;
          font-weight: bold;
          text-transform: uppercase;
          margin: 0 auto;
        }
        #urlText {
          font-family: "Roboto";
          font-size: 8px;
          text-align: center;
          font-weight: bold;
          text-transform: lowercase;
          margin: 0 auto;
          padding-top: 10px;
        }
      }
      `,
      "https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Material+Icons",
    ];

    const d = new Printd();
    return d.print(content, css, "", (callback) => {
      const { iframe, launchPrint } = callback;
      const { contentWindow } = iframe;
      contentWindow.addEventListener("afterprint", () => {
        postRequest.object("/print", { type: "temporary-parts", id });
      });
      launchPrint();
    });
  });
}

async function printMultipleQrCodes(parts) {
  const content = document.createElement("div");
  content.setAttribute("id", "content");

  const qrPromises = parts.map((part) => {
    return new Promise((resolve, reject) => {
      QrCode.toDataURL(part._id, (error, url) => {
        if (error) return reject(error);
        resolve({ part, url });
      });
    });
  });

  const qrResults = await Promise.all(qrPromises);

  // No slicing — print all, one per line
  qrResults.forEach(({ part, url }) => {
    const partComp = document.createElement("div");
    partComp.className = "part"; // now 1 per line

    const qrImage = document.createElement("img");
    qrImage.src = url;
    qrImage.className = "qrImage";
    qrImage.style.width = "100px";
    qrImage.style.height = "100px";
    const idComp = document.createElement("div");
    idComp.textContent = part._id.slice(-6);
    idComp.className = "idText";

    const urlComp = document.createElement("div");
    urlComp.textContent = "www.lekotech.com";
    urlComp.className = "urlText";

    partComp.appendChild(qrImage);
    partComp.appendChild(idComp);
    partComp.appendChild(urlComp);

    content.appendChild(partComp);
  });

  const css = [
    `
@media print {
  @page {
          size: 4cm, 3cm;
          size: portrait;
        }
        body {
          height: 100%;
          width: 100%;
        }
  .part {
  text-align: center;
  }
  .qrImage {
    object-fit: contain;
    display: block;
    margin: 0 auto;
  }

  .idText {
    font-family: "Roboto";
    font-size: 3.2mm;       
    font-weight: bold;
    text-align: center;
    text-transform: uppercase;
  }

  .urlText {
    font-family: "Roboto";
    font-size: 2mm;
    font-weight: bold;
    margin-top: 1mm;
    text-align: center;
  }
}
`,
  ];

  const d = new Printd();

  return d.print(content, css, "", (callback) => {
    const { iframe, launchPrint } = callback;

    iframe.contentWindow.addEventListener("afterprint", () => {
      postRequest.object("/print", {
        type: "temporary-parts",
        ids: parts.map((p) => p._id),
      });
    });

    launchPrint();
  });
}

export default {
  components: {
    "qr-code": VueQrCode,
  },
  data: () => ({
    dialog: false,
    parts: [],
  }),
  watch: {
    dialog(value) {
      if (!value) {
        this.parts = [];
      }
    },
  },
  methods: {
    open(data) {
      this.parts = data;
      this.dialog = true;
    },
    print() {
      printMultipleQrCodes(this.parts);
    },
    printSingle(id) {
      printSingleQrCode(id);
    },
  },
};
</script>
